import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

const SelectCheckBox = ({ item, itemIndex, onSelected }) => (
  <Checkbox
    checked={item.Selected === undefined ? false : item.Selected}
    className="table__checkbox"
    onClick={() => onSelected(itemIndex)}
  />
);

SelectCheckBox.propTypes = {
  /** Elemento bindato alla riga della tabella */
  item: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /** Indice dell'elemento bindato */
  itemIndex: PropTypes.number,
  /**
   *  Callback invocata alla selezione
   * ```
   *  onSelected(itemIndex)
   * ```
   * dove:
   * * *itemIndex*: indice dell'elemento
   */
  onSelected: PropTypes.func,
};

SelectCheckBox.defaultProps = {
  item: {},
  itemIndex: 0,
  onSelected: null,
};

export default SelectCheckBox;
